import { Component, OnInit, Input, ViewEncapsulation } from "@angular/core";
import { FormControl } from "@angular/forms";
import Swal from "sweetalert2";
import { AngularEditorConfig } from "@kolkov/angular-editor";
import { User, Comment, Discussion } from "../../../../../models";
import { CommentService } from "../../../../../services";

@Component({
  selector: "comment-editor-form",
  templateUrl: "./comment-editor-form.component.html",
  styleUrls: [
    "./comment-editor-form.component.scss",
    "../../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
  encapsulation: ViewEncapsulation.None,
})
export class CommentEditorForm implements OnInit {
  public editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: "7rem",
    minHeight: "5rem",
    placeholder: "Enter text here...",
    translate: "no",
    uploadUrl: "v1/images",
    customClasses: [
      {
        name: "quote",
        class: "quote",
      },
      {
        name: "redText",
        class: "redText",
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ],
  };

  public defaultUserImg: string =
    "../../../../../../../assets/images/uMuzi/african-mask.png";
  public commentToPost: any = {};
  public isSubmitting = false;
  public commentControl = new FormControl();
  public commentFormErrors = {};

  @Input() currentUser: User;
  @Input() discussion: Discussion;
  @Input() commentRepliedTo: Comment;
  @Input() commentToEdit: Comment;

  ngOnInit() {}

  ngOnChanges() {
    this.updateReply();
    this.updateEdit();
  }

  constructor(private commentService: CommentService) {
    this.commentControl.valueChanges.subscribe((value) => {
      this.commentToPost["body"] = value;
    });
  }

  public updateReply() {
    if (this.commentRepliedTo) {
      this.commentToPost = {};
      if (this.commentRepliedTo.parents.length === 0) {
        this.commentToPost["parentId"] = this.commentRepliedTo.id;
      } else if (this.commentRepliedTo.parents.length === 1) {
        this.commentToPost["parentId"] = this.commentRepliedTo.parents[0];
      }

      if (this.currentUser.username !== this.commentRepliedTo.author.username) {
        this.commentToPost["replyTo"] = this.commentRepliedTo.author.username;
      }
    }
  }

  public updateEdit() {
    if (this.commentToEdit) {
      this.commentToPost = {};
      this.commentControl.setValue(this.commentToEdit.body);
      this.commentToPost["id"] = this.commentToEdit.id;
    }
  }

  public saveComment() {
    this.isSubmitting = true;
    this.commentFormErrors = {};

    this.commentService.saveOne(this.discussion, this.commentToPost).subscribe(
      (comment) => {
        this.commentControl.reset("");
        this.isSubmitting = false;
        this.fireSuccessAlert();
      },
      (errors) => {
        this.isSubmitting = false;
        this.commentFormErrors = errors;
        this.fireErrorAlert();
      }
    );
  }

  public fireSuccessAlert() {
    Swal.fire({
      title: "Published",
      text: "Your comment has been published",
      type: "success",
    }).then(function () {
      window.location.reload();
    });
  }

  public fireErrorAlert() {
    Swal.fire("Eish!", "There were errors with your submission.", "warning");

    function errorAlert() {
      Swal.close();
    }
    setTimeout(errorAlert, 3000);
  }

  public openCommentPublishConfirmation() {
    Swal.fire({
      title: "Publish comment?",
      text: "Sure you want to publish this comment?",
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Haai, cancel!",
      confirmButtonText: "Yebo, publish!",
    }).then((result) => {
      if (result.value) {
        this.saveComment();
      }
    });
  }
}
